module.exports = {"helmetTitle":"Veloe - Criar senha","title":"Oi,","subtitle":"Tickets de estacionamento e filas de pedágio vão sair da sua vida. Crie uma senha com seis caracteres e pelo menos uma letra e um número.","modalTitle":"Pronto! A gente já salvou suas alterações. ;)"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/FirstAccessCreatePassword/data.json
// module id = 1784
// module chunks = 0